import { render, staticRenderFns } from "./HotCourse.vue?vue&type=template&id=fffe0e36&scoped=true"
import script from "./HotCourse.vue?vue&type=script&lang=js"
export * from "./HotCourse.vue?vue&type=script&lang=js"
import style0 from "./HotCourse.vue?vue&type=style&index=0&id=fffe0e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffe0e36",
  null
  
)

export default component.exports